/* Display-only adapter for the current Opus drawer. Never writes cart prices or properties. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  // Configurator lines with a price list (same nine configs as buddy-lpo-exact-compare.js).
  var scope = new Set(['clac4aiq7aiz', 'cluuvirqr1ii', 'clay7u37oq9f', 'clhuflsw3euz', 'clmfj71riyta', 'clkzcreg5nfa', 'clc0pjuaxvy0', 'clrsnau0lznu', 'clqrtvgloipr']);
  function integer(value) {
    if ((typeof value !== 'number' && typeof value !== 'string') || !/^\d+$/.test(String(value))) return null;
    value = Number(value);
    return Number.isSafeInteger(value) ? value : null;
  }
  function money(value) {
    return '€' + new Intl.NumberFormat('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value / 100);
  }
  function parseMoney(text) {
    // This shop's verified format; refuse foreign/ambiguous currency formats.
    var clean = String(text).replace(/€/g, '').replace(/[\s\u00a0]/g, '');
    if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+),\d{2}$/.test(clean)) return null;
    return integer(clean.replace(/\./g, '').replace(',', ''));
  }
  // Strike price only from the exact PDP value _buddy_listenpreis = "<strike>@<paid unit>",
  // accepted only if <paid unit> equals this line's unit price. Otherwise none (no estimate).
  function calculate(item) {
    var props = (item && item.properties) || {};
    if (!item || !scope.has(props._cl_options)) return null;
    var original = integer(item.original_price), quantity = integer(item.quantity);
    var finalLine = integer(item.final_line_price);
    var parts = String(props._buddy_listenpreis || '').split('@');
    if (parts.length !== 2 || !original || !quantity || finalLine === null) return null;
    var strike = integer(parts[0]), paid = integer(parts[1]);
    if (!strike || paid !== original || strike <= original) return null;
    var total = strike * quantity, saving = (strike - original) * quantity;
    if (!Number.isSafeInteger(total) || saving <= 0 || total <= finalLine) return null;
    return {unit: strike, total: total, saving: saving};
  }
  function rowInfo(row) {
    var link = row.querySelector('a[href*="variant="]');
    var amount = row.querySelector('.opus-final-price');
    var qty = row.querySelector('.cd-number-input-field');
    if (!link || !amount || !qty) return null;
    var match = link.getAttribute('href').match(/[?&]variant=(\d+)(?:&|$)/);
    return match ? {id: match[1], total: parseMoney(amount.textContent), quantity: integer(qty.value)} : null;
  }
  function clear(row) {
    row.removeAttribute('data-buddy-compare-managed');
    row.querySelectorAll('[data-buddy-lpo-comparison]').forEach(function (el) { el.remove(); });
  }
  function suppress(row) { clear(row); row.setAttribute('data-buddy-compare-managed', ''); }
  function render(shadow, cart, variants) {
    if (!cart || !Array.isArray(cart.items)) { shadow.querySelectorAll('[data-buddy-compare-managed]').forEach(suppress); return; }
    shadow.querySelectorAll('.cd-product-item-content').forEach(function (row) {
      var info = rowInfo(row), target = row.querySelector('.opus-price-display');
      if (!info || !target || !info.quantity) { clear(row); return; }
      var possible = cart.items.filter(function (i) { return String(i.variant_id) === info.id && i.quantity === info.quantity; });
      var scoped = possible.length > 0 && possible.every(function (i) { return scope.has((i.properties || {})._cl_options); });
      if (cart.currency !== 'EUR' || info.total === null) { if (scoped) suppress(row); else clear(row); return; }
      // Match the actual rendered line, including quantity/amount, not the variant alone.
      var matches = cart.items.filter(function (i) {
        return String(i.variant_id) === info.id && i.quantity === info.quantity && i.final_line_price === info.total;
      });
      var outcomes = matches.map(function (item) { return calculate(item, variants[info.id]); });
      var outcome = outcomes[0];
      if (!outcome || outcomes.some(function (o) { return !o || o.total !== outcome.total || o.saving !== outcome.saving; })) {
        if (scoped) suppress(row); else clear(row); return;
      }
      var node = target.querySelector('[data-buddy-lpo-comparison]');
      if (!node) {
        node = row.ownerDocument.createElement('span');
        node.setAttribute('data-buddy-lpo-comparison', '');
        var strike = row.ownerDocument.createElement('s');
        var saving = row.ownerDocument.createElement('span');
        node.appendChild(strike); node.appendChild(saving); target.appendChild(node);
      }
      var priceText = money(outcome.total), savingText = 'Produkt-Rabatt: −' + money(outcome.saving);
      if (node.children[0].textContent !== priceText) node.children[0].textContent = priceText;
      if (node.children[1].textContent !== savingText) node.children[1].textContent = savingText;
      row.setAttribute('data-buddy-compare-managed', '');
    });
  }
  function install(win) {
    var doc = win.document;
    if (doc.documentElement.hasAttribute('data-buddy-compare-installed')) return;
    doc.documentElement.setAttribute('data-buddy-compare-installed', '');
    var node = doc.getElementById('buddy-lpo-compare-data'), variants = Object.create(null), records;
    try { records = JSON.parse(node.textContent); } catch (e) { return; }
    if (!Array.isArray(records)) return;
    records.forEach(function (v) { if (integer(v.id) && integer(v.price)) variants[String(v.id)] = v; });
    var shadow = null, timer = null, observer = null, running = false, pending = false;
    var bodyObserver;
    function ownMutation(m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      if (el && el.closest && el.closest('[data-buddy-lpo-comparison]')) return true;
      if (m.type === 'childList') {
        var nodes = Array.from(m.addedNodes).concat(Array.from(m.removedNodes));
        return nodes.length > 0 && nodes.every(function (n) {
          return n.nodeType === 1 && (n.hasAttribute('data-buddy-lpo-comparison') || (n.id === 'buddy-lpo-compare-style' && m.addedNodes.length > 0));
        });
      }
      return false;
    }
    function queue() {
      win.clearTimeout(timer);
      timer = win.setTimeout(refresh, 150);
    }
    function ensureStyle() {
      if (!shadow || shadow.querySelector('#buddy-lpo-compare-style')) return;
      var style = doc.createElement('style');
      style.id = 'buddy-lpo-compare-style';
      style.textContent = '[data-buddy-compare-managed] .opus-original-price,[data-buddy-compare-managed] .opus-discount-price{display:none!important}[data-buddy-lpo-comparison]{display:flex;flex-direction:column;align-items:flex-end;gap:3px;font-size:12px}[data-buddy-lpo-comparison] s{opacity:.7}';
      shadow.appendChild(style);
    }
    async function refresh() {
      ensureStyle();
      if (!shadow || !shadow.querySelector('.cd-product-item-content')) return;
      if (running) { pending = true; return; }
      running = true;
      try {
        var cartPath = win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/';
        var response = await win.fetch(cartPath + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error('Cart read failed');
        var cart = await response.json();
        updateDisplay(function () { render(shadow, cart, variants); });
      } catch (e) {
        // Leave checkout and payable values to Shopify/LPO on any network failure.
        updateDisplay(function () { shadow.querySelectorAll('[data-buddy-compare-managed]').forEach(suppress); });
      } finally {
        running = false;
        if (pending) { pending = false; queue(); }
      }
    }
    function updateDisplay(update) {
      // Synchronous own DOM writes must not start another cart read.
      if (observer) observer.disconnect();
      try { update(); } finally {
        if (observer && shadow) observer.observe(shadow, {subtree: true, childList: true, characterData: true});
      }
    }
    function bind() {
      var host = doc.getElementById('opus-shadow-container');
      if (!host || !host.shadowRoot || host.shadowRoot === shadow) return;
      if (observer) observer.disconnect();
      shadow = host.shadowRoot;
      ensureStyle();
      observer = new win.MutationObserver(function (changes) {
        if (changes.some(function (m) { return !ownMutation(m); })) queue();
      });
      observer.observe(shadow, {subtree: true, childList: true, characterData: true});
      queue();
    }
    bind();
    var attempts = 0;
    function awaitShadow() {
      bind();
      if (!shadow && ++attempts < 40) win.setTimeout(awaitShadow, 250);
    }
    if (!shadow) awaitShadow();
    bodyObserver = new win.MutationObserver(bind);
    bodyObserver.observe(doc.body, {childList: true, subtree: true});
    function wake() { bind(); queue(); }
    doc.addEventListener('cartItems', wake);
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) wake(); });
  }
  return {calculate: calculate, parseMoney: parseMoney, render: render, install: install};
});
